module.exports = __webpack_public_path__ + "img/face_user.216f5adf.svg";